import React from "react";
import { Link } from "react-router-dom";

const TermsPrivacy = () => {
  const isLoggedIn = sessionStorage.getItem("accessToken");

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div
            className="card-header"
            style={{ backgroundColor: "var(--color-primary-green)" }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="card-title text-white">📜 Terms & Conditions</h4>
                <p className="text-white mb-0">
                  <strong className="text-white">Effective Date:</strong> 22
                  September 2025
                  <br />
                  <strong className="text-white">Platform:</strong> Morvi Bazaar
                  (operated by Silkera Ceramic)
                  <br />
                  <strong className="text-white">Email:</strong>{" "}
                  info@morvibazaar.com
                  <br />
                  <strong className="text-white">Jurisdiction:</strong> Morbi,
                  Gujarat, India
                </p>
              </div>
              {!isLoggedIn && (
                <div className="d-flex gap-2">
                  <Link
                    to="/login"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#ffffff",
                      color: "var(--color-primary-green)",
                      border: "1px solid #ffffff",
                    }}
                  >
                    <i className="fe fe-log-in me-1"></i> Login
                  </Link>
                  <Link
                    to="/signup"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "var(--color-primary-green)",
                      color: "#ffffff",
                      border: "1px solid #ffffff",
                    }}
                  >
                    <i className="fe fe-user-plus me-1"></i> Sign Up
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="legal-content">
              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  1. Introduction
                </h5>
                <p>
                  Welcome to Morvi Bazaar, a B2B subscription-based digital
                  marketplace connecting verified ceramic buyers and sellers.
                  These Terms & Conditions govern your use of the Morvi Bazaar
                  mobile app (for buyers) and website (for sellers). By
                  accessing or using the platform, you agree to these Terms.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  2. Platform Overview
                </h5>
                <ul>
                  <li>
                    <strong>Buyers (Mobile App):</strong> Only GST-registered
                    dealers/shop owners can register.
                  </li>
                  <li>
                    <strong>Sellers (Website):</strong> Only manufacturers and
                    stockists may register and list products.
                  </li>
                  <li>
                    Sellers may upload stock data (PDF/images), create a
                    business profile (bio, contact, catalog), and access
                    advertising features.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  3. Registration & Subscription
                </h5>
                <ul>
                  <li>
                    Buyers must register via the mobile app with valid business
                    and GST details.
                  </li>
                  <li>
                    Buyers may use one free feature to submit product
                    requirements, which Morvi Bazaar forwards to subscribed
                    sellers.
                  </li>
                  <li>
                    A subscription is required to view seller listings and
                    catalogs.
                  </li>
                  <li>
                    Sellers must subscribe via the website to list stock and
                    access full features.
                  </li>
                  <li>Subscription fees are final and payable via Razorpay.</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  4. Buyer–Seller Interaction
                </h5>
                <ul>
                  <li>
                    Buyers may contact sellers directly using the WhatsApp
                    inquiry button.
                  </li>
                  <li>
                    Morvi Bazaar does not participate in product negotiations,
                    payments, delivery, or after-sales. All terms are decided
                    between buyer and seller.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  5. Stock Listing & Visibility
                </h5>
                <ul>
                  <li>
                    Seller visibility depends on reviews and optional sponsored
                    listings.
                  </li>
                  <li>
                    Higher-rated sellers may appear first in search results.
                  </li>
                  <li>Ad space is available only to subscribed sellers.</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  6. Reviews & Moderation
                </h5>
                <ul>
                  <li>Only buyers can post reviews.</li>
                  <li>
                    Reviews may be moderated, edited, or removed if found
                    misleading, abusive, or fraudulent.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  7. Fraud & Misuse Policy
                </h5>
                <ul>
                  <li>
                    All accounts undergo manual verification, but we do not
                    guarantee 100% fraud prevention.
                  </li>
                  <li>
                    Accounts found misusing the platform may be suspended or
                    deleted without refund.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  8. Payment Terms
                </h5>
                <ul>
                  <li>Subscriptions are processed via Razorpay.</li>
                  <li>
                    All subscription payments are non-refundable, except where
                    required by law.
                  </li>
                  <li>
                    Morvi Bazaar does not handle product payments and is not
                    liable for disputes between buyers and sellers.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  9. Intellectual Property
                </h5>
                <ul>
                  <li>
                    All content, branding, and platform design belong to Silkera
                    Ceramic.
                  </li>
                  <li>
                    No part of the platform may be copied, reproduced, or reused
                    without written permission.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  10. Termination of Account
                </h5>
                <ul>
                  <li>
                    Users may request account deletion anytime, but no
                    subscription refunds will be provided.
                  </li>
                  <li>
                    Morvi Bazaar reserves the right to terminate accounts that
                    violate these Terms.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  11. Limitation of Liability
                </h5>
                <ul>
                  <li>
                    Morvi Bazaar acts only as a digital listing and
                    communication platform.
                  </li>
                  <li>
                    We are not liable for fraud, non-delivery of products, loss
                    of business, or disputes between buyers and sellers.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  12. Jurisdiction
                </h5>
                <p>
                  All disputes shall be subject to the exclusive jurisdiction of
                  courts at Morbi, Gujarat, India.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  13. Modifications
                </h5>
                <p>
                  We may update these Terms at any time. Continued use of the
                  platform constitutes acceptance of the revised Terms.
                </p>
              </section>

              <hr className="my-5" />
               <section className="mb-4">
                 <h5 style={{ color: "var(--color-primary-green)" }}>
                   🚚 Shipping & Delivery Policy
                 </h5>
                 <p>Not applicable as this is a digital subscription service</p>
               </section>
              <hr className="my-5" />

              <section className="mb-4">
                <h4 style={{ color: "var(--color-primary-green)" }}>
                  🔒 Privacy Policy
                </h4>
                <p className="text-muted mb-3">
                  <strong>Effective Date:</strong> 25 September 2025
                  <br />
                  <strong>Operated by:</strong> Silkera Ceramic
                  <br />
                  <strong>Email:</strong> info@morvibazaar.com
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  1. Information We Collect
                </h5>

                <h6 className="text-secondary mt-3">From Buyers:</h6>
                <ul>
                  <li>Business and owner name</li>
                  <li>Mobile number</li>
                  <li>GST number</li>
                  <li>Purchase interests</li>
                  <li>Reviews posted</li>
                  <li>Location data (manual/GPS)</li>
                </ul>

                <h6 className="text-secondary mt-3">From Sellers:</h6>
                <ul>
                  <li>Firm and owner name</li>
                  <li>GST number and address</li>
                  <li>Stock data (PDFs/images)</li>
                  <li>Profile bios, catalogs</li>
                  <li>Ad content (if applicable)</li>
                </ul>

                <h6 className="text-secondary mt-3">From Both:</h6>
                <ul>
                  <li>Subscription and payment data (via Razorpay)</li>
                  <li>WhatsApp links for inquiries</li>
                  <li>IP address and device identifiers</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  2. How We Use the Data
                </h5>
                <p>We use collected data to:</p>
                <ul>
                  <li>Verify user authenticity</li>
                  <li>Match buyers with relevant sellers</li>
                  <li>Display listings and profile pages</li>
                  <li>Manage advertisements</li>
                  <li>Process payments securely</li>
                  <li>Monitor usage patterns and prevent misuse</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  3. Sharing & Disclosure
                </h5>
                <ul>
                  <li>We do not sell or rent user data.</li>
                  <li>
                    We may share data with:
                    <ul>
                      <li>Razorpay (for payment processing)</li>
                      <li>
                        Trusted third-party tools (WhatsApp Business API,
                        email/SMS services, cloud hosting)
                      </li>
                    </ul>
                  </li>
                  <li>
                    Data may be disclosed if required by law or to protect the
                    platform from abuse.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  4. Security & Storage
                </h5>
                <ul>
                  <li>
                    We use technical and organizational safeguards to protect
                    data.
                  </li>
                  <li>
                    No system is 100% secure; users share information at their
                    own risk.
                  </li>
                  <li>
                    Data is retained only as long as needed for services, legal
                    compliance, or dispute resolution.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  5. Reviews & Moderation
                </h5>
                <ul>
                  <li>Only buyers may post reviews.</li>
                  <li>
                    Reviews may be edited or removed if misleading, abusive, or
                    fake.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  6. WhatsApp Integration
                </h5>
                <ul>
                  <li>
                    Each seller profile includes a WhatsApp inquiry button.
                  </li>
                  <li>
                    Communication after leaving the platform is not tracked or
                    controlled by Morvi Bazaar.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  7. User Rights
                </h5>
                <p>Users may:</p>
                <ul>
                  <li>Request correction of inaccurate data</li>
                  <li>
                    Request account deletion (excluding mandatory transaction
                    records)
                  </li>
                  <li>Opt out of promotional emails or notifications</li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  8. Children's Privacy
                </h5>
                <p>
                  The platform is designed for business users above 18. We do
                  not knowingly collect data from minors.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  9. International Use
                </h5>
                <p>
                  The platform is intended for users in India. If accessed from
                  abroad, you consent to processing of your data in India.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  10. Consent
                </h5>
                <p>
                  By registering and using Morvi Bazaar, you consent to the
                  collection and processing of your data as outlined in this
                  policy.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  11. Changes to This Policy
                </h5>
                <p>
                  We may revise this Privacy Policy at any time. Updated
                  versions will be posted on our platform.
                </p>
              </section>

              <hr className="my-5" />

              <section className="mb-4">
                <h4 style={{ color: "var(--color-primary-green)" }}>
                  💳 Refund & Cancellation Policy
                </h4>
                <p className="text-muted mb-3">
                  <strong>Effective Date:</strong> 25 September 2025
                  <br />
                  <strong>Operated by:</strong> Silkera Ceramic (Morvi Bazaar)
                  <br />
                  <strong>Email:</strong> info@morvibazaar.com
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  1. Subscription Payments
                </h5>
                <ul>
                  <li>
                    All subscriptions (monthly, quarterly, yearly) purchased on
                    Morvi Bazaar are non-refundable once activated.
                  </li>
                  <li>
                    Users are advised to review their plan carefully before
                    making payment.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  2. No Cancellation of Active Subscriptions
                </h5>
                <ul>
                  <li>
                    Once a subscription is active, it cannot be canceled or
                    paused midway.
                  </li>
                  <li>
                    Users may choose not to renew after the current subscription
                    period ends.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  3. Auto-Renewal
                </h5>
                <p>
                  Morvi Bazaar does not auto-renew subscriptions. Users must
                  manually renew if they wish to continue.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  4. Exceptions (Refunds Only in Rare Cases)
                </h5>
                <p>
                  Refunds will only be considered in the following
                  circumstances:
                </p>
                <ul>
                  <li>
                    <strong>Duplicate Payment</strong> – If a user is charged
                    twice for the same subscription due to a technical error.
                  </li>
                  <li>
                    <strong>Failed Transaction</strong> – If the user is
                    charged, but subscription activation fails.
                  </li>
                </ul>
                <p>In such cases:</p>
                <ul>
                  <li>
                    The user must email{" "}
                    <a href="mailto:silkeraceramic@gmail.com">
                      silkeraceramic@gmail.com
                    </a>{" "}
                    within 7 days of payment with proof of transaction.
                  </li>
                  <li>
                    Refunds (if approved) will be processed back to the original
                    payment method within 7–10 working days.
                  </li>
                </ul>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  5. Account Suspension/Termination
                </h5>
                <p>
                  If a user account is terminated due to misuse, fraud, or
                  policy violation, no refund will be issued.
                </p>
              </section>

              <section className="mb-4">
                <h5 style={{ color: "var(--color-primary-green)" }}>
                  7. Contact for Refund Queries
                </h5>
                <p>For refund-related questions, users can contact:</p>
                <p>
                  <strong>📧 Email:</strong>{" "}
                  <a href="mailto:info@morvibazaar.com">info@morvibazaar.com</a>
                </p>
                <p>
                  <strong>📞 Phone:</strong>{" "}
                  <a href="tel:+917600090040">+91 7600090040</a>,{" "}
                  <a href="tel:+919998998090">+91 9998998090</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPrivacy;
